'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
var parcelHowDoesItWorkBoxComponent = exports.parcelHowDoesItWorkBoxComponent = {
    template: require('./parcel-how-does-it-work-box.html'),
    bindings: {},
    controllerAs: 'vm',
    controller: function parcelHowDoesItWorkBoxController() {
        'ngInject';
    }
};


//////////////////
// WEBPACK FOOTER
// ./features/account/parcels/components/parcel-how-does-it-work-box.js
// module id = 876
// module chunks = 0